<header class="header">
  <div class="menu-icon d-lg-none" (click)="sideMenu()">
    <i class="fa-solid fa-bars fa-2x"></i>
  </div>
<div class="menu-icon d-none d-lg-flex">
  <span class="menu-toggle-text" (click)="toggleMenu()">
    <i class="fa-solid" [ngClass]="isToggle ? 'fa-angle-left' : 'fa-angle-right'"></i>
    {{ isToggle ? 'show menu' : 'hide menu' }}
  </span>
</div>


<div class="header-logos">
  <a href="https://heydata.eu" target="_blank" title="heyData GDPR seal" class="header-logo">
    <img
      src="https://privacy-seal.heydata.eu/seal/07bee25e-319a-4aa6-9e08-567767d16d26?lang=de&design=design2&sealType=GDPR"
      alt="heyData trusted logo"
    />
  </a>

  <div class="header-logo header-logo-2fa" title="Two-Factor Authentication Secured">
    <img src="assets/images/Bild.png" alt="2FA Security" />
  </div>

  <div class="header-logo header-logo-madeingermany" title="Software Made in Germany seal">
    <img src="assets/images/Bild_made.png" alt="Software Made in Germany" />
  </div>
</div>


  <div class="menu gap-2">
    <button class="btn btn-primary button-bug-mobile" (click)="openBugWidget()"> {{ 'Feedback' | translate }} </button>

<!--     <div class="language-menu">
      <div class="language-select">
        <div class="selected-flag language-name" (click)="toggleLangugaeDropdown()">
          <i class="fa-regular fa-globe"></i>
          <span class="lang-code">{{ selectedLanguage === 'en' ? 'ENG' : 'DEU' }}</span>
        </div>
        <div class="flag-dropdown" *ngIf="dropdownOpen">
          <div class="flag-option" (click)="switchLanguage('en')">English</div>
          <div class="flag-option" (click)="switchLanguage('de')">Deutsch</div>
        </div>
      </div>
    </div> -->
    <div class="profile-container" (click)="toggleDropdown()">
      <div class="profile-info">
        <img src="/assets/images/user.jpg" alt="Profile" class="profile-photo" />
        <div class="user-info">
          <div class="user-name">{{name}}</div>
          <div class="user-role">{{role === 1 ? "Admin" : "Customer"}}</div>
          <div class="user-customer-number" *ngIf="customerNumber">{{customerNumber}}</div>
        </div>
      </div>
      <ul class="dropdown-list" [ngClass]="{'show': isDropdownOpen}">
        <li (click)="goToProfile()"><a>{{ "Profile" | translate }}</a></li>
        <li (click)="open2FAModal()"><a>{{"Enable 2FA"| translate}}</a></li>
        <!--<li><a href="#">{{ "Settings" | translate }}</a></li> -->
        <li (click)="logout()"><a>{{ "Logout" | translate }}</a></li>
      </ul>
    </div>
  </div>
</header>